// frontend/src/pages/admin/lcl/api/lclClient.js
import axios from 'axios';
import { supabase } from '../../../../lib/supabaseClient';

const api = axios.create({ baseURL: '/api/lcl' });

api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
});

export const lclClient = {
  getSettings: () => api.get('/settings').then((r) => r.data.data),
  updateSettings: (patch) => api.put('/settings', patch).then((r) => r.data.data),
  listMandates: (params) => api.get('/mandates', { params }).then((r) => r.data.data),
  exportMandates: (ics_scope) => api.post('/mandates/export', { ics_scope }).then((r) => r.data),
  listPrelevements: (params) => api.get('/prelevements', { params }).then((r) => r.data.data),
  listCollisions: (date_reglement) =>
    api.get('/prelevements/collisions', { params: { date_reglement } }).then((r) => r.data.data),
  exportPrelevements: ({ date_reglement, invoice_ids, resolution_strategy }) =>
    api.post('/prelevements/export', { date_reglement, invoice_ids, resolution_strategy })
       .then((r) => r.data),
  correctRib: (accountId, { iban, bic }) =>
    api.patch(`/accounts/${accountId}/rib`, { iban, bic }).then((r) => r.data.data),
  listBatches: (params) => api.get('/batches', { params }).then((r) => r.data.data),
  downloadBatchUrl: (id) => `/api/lcl/batches/${id}/download`,
};
